import script from "./DisdiSettingsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisdiSettingsTab.vue?vue&type=script&setup=true&lang=ts"

import "./DisdiSettingsTab.vue?vue&type=style&index=0&id=5e5ebe42&scoped=true&lang=css"

import exportComponent from "C:\\Users\\digi_aj\\source\\repos\\1ANAB_Vue_Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5ebe42"]])

export default __exports__